import React from 'react';

import { Alert, Button } from '@mui/material';

export type DeclareNowBannerProps = {
  declaring?: boolean;
  onDeclareNow?: () => void;
};

/**
 * The cue that gets an undeclared custom dataset out of its empty state,
 * surfaced on Data and Filters (not only on Source, where a reader is least
 * likely to be when the emptiness is actually felt). A thin wrapper around
 * Source's own "Declare now" alert (`DatasetFacts.tsx`); same handler, same
 * one dry run, just shown where the problem shows up.
 */
export default function DeclareNowBanner({ declaring, onDeclareNow }: DeclareNowBannerProps) {
  return (
    <Alert
      action={
        <Button disabled={declaring || !onDeclareNow} onClick={onDeclareNow} size="small">
          {declaring ? 'Declaring…' : 'Declare now'}
        </Button>
      }
      severity="info"
      sx={{ alignItems: 'center' }}
      variant="outlined"
    >
      This dataset&rsquo;s columns aren&rsquo;t declared yet, so there&rsquo;s nothing to pick from.
    </Alert>
  );
}
